import React from "react";
import "./Topbar.css";
import logo from "./Swajit.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faFacebook,faLinkedin,faTwitter,} from "@fortawesome/free-brands-svg-icons";
import { Link } from "react-router-dom";

function Topbar() {
  return (
    <div className="topbar">
      <p>
        Contact us on :+91 9922941689 or +91-240-2555031 or marketing@swajit.com
      </p>
      <div className="img">
        {/* <a href="/home"><img src={logo} alt="img" /></a> */}
        <div className="social-icon">
          <Link target="_blank" to="https://x.com/swajit_engg"><FontAwesomeIcon className="icon" icon={faTwitter} /></Link>
          <Link target="_blank" to="https://www.facebook.com/swajitengineering/"><FontAwesomeIcon className="icon" icon={faFacebook} /></Link>
          <Link target="_blank" to="https://www.linkedin.com/company/swajit-engineering-p-ltd?originalSubdomain=in"><FontAwesomeIcon className="icon" icon={faLinkedin} /></Link>
        </div>
        <div className="topimg">
        <a href="/home"><img src={logo} alt="img" /></a>
</div>
      </div>
    </div>
  );
}

export default Topbar;
